import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SkapaText } from '@inter-ikea-guida/skapa';
import { StyledLabelText, StyledLabel } from './styles';
export const ButtonLabel = ({ htmlFor, subtle, text, description }) => {
    return (_jsxs(StyledLabel, { htmlFor: htmlFor, children: [_jsx(StyledLabelText, { "$subtle": subtle, textStyle: 'Body.M', children: text }), description && _jsx(SkapaText, { textStyle: 'Body.M', children: description })] }));
};
//# sourceMappingURL=ButtonLabel.js.map